// Session 55.ab · Shared image component with URL resolution + fallback.
// - Resolves relative `/api/uploads/...` paths through REACT_APP_BACKEND_URL
//   so the image always loads, even if the frontend + backend are on
//   different hosts.
// - On load failure, swaps in the default Métier placeholder (never a
//   broken-image icon) and logs the failed URL to the console for QA.
// - Lazy-loads by default; opt into eager with `eager` prop.
// - Passes through className/style/alt/etc for drop-in replacement of <img>.
import { useState } from "react";

const PLACEHOLDER = "/brand/metier-logo.png";

export function resolveImageSrc(u) {
  if (!u) return "";
  if (/^https?:\/\//i.test(u) || u.startsWith("data:")) return u;
  if (u.startsWith("/api/")) {
    const base = process.env.REACT_APP_BACKEND_URL || "";
    return base ? `${base}${u}` : u;
  }
  return u;
}

export default function Img({ src, alt = "", eager = false, fallback = PLACEHOLDER, onError, ...rest }) {
  const [errored, setErrored] = useState(false);
  const resolved = resolveImageSrc(src);
  const finalSrc = errored ? fallback : (resolved || fallback);
  return (
    <img
      src={finalSrc}
      alt={alt}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      onError={(e) => {
        if (!errored) {
          console.warn("[Img] failed to load", { src, resolved });
          setErrored(true);
        }
        onError?.(e);
      }}
      {...rest}
    />
  );
}
